import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.clients.views.ClientView.';
  public static readonly saveClient = `${Id.prefix}saveClient`;
}

export class LangClientView {
  private constructor() {}
  public static saveClient(): string {
    return interpolate(Id.saveClient);
  }
}

export class ClientViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.saveClient, "Save {{glossary 'client'}}", 'Button label for saving a client');
  }
}
